(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/team-members/member-name.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/team-members/member-name.js');
'use strict';

const MemberName = _ref => {
  let firstName = _ref.firstName,
    lastName = _ref.lastName;
  return React.createElement("div", {
    className: "f-bold"
  }, !(firstName || lastName) && 'Anonym kund', React.createElement("span", {
    className: "data-hj-suppress"
  }, (firstName || lastName) && "".concat(firstName, " ").concat(lastName)));
};
svs.arena.pages.teams.teamMembers.MemberName = MemberName;

 })(window);